import { createFetcher } from '../contexts/Fetcher';
import { apiProductPlan } from '../resources/api/apiProductPlan';
import { useIntQueryParam } from '../hooks/useQueryParam';

const { useGetPlan } = apiProductPlan;

export const ProductPlanFetcher = createFetcher(() => {
  const id = useIntQueryParam('edit');
  const { execute: getPlan } = useGetPlan(id ?? void 0);

  return getPlan;
});
